import React from "react";
import "./ECommerceComponents.css";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { useState, useEffect } from "react";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import AddStore from "../ECommerceComponents/AddStore";
import { Url } from "../../Services/Api";
import BottomToust from "../../Components/BottomToust/BottomToust";

const StoreLocator = () => {
  const rowsPerPage = 5;
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showAddStore, setShowAddStore] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTableData();
  }, []);

  async function fetchTableData() {
    setLoading(true);
    setError(null);
    setTimeout(async () => {
      try {
        const URL = `${Url}/api/v1/stores/get`;
        const response = await fetch(URL);
        const result = await response.json();
        setData(result.data);
        setToastMessage("All Stores have been fetched successfully!");
        setShowMessage(true);
      } catch (error) {
        const errMsg = error?.response?.data?.message || error.message;
        setError(errMsg);
        setToastMessage(`Failed to fetch All Stores: ${errMsg}`);
        setShowMessage(true);
      } finally {
        setLoading(false);
      }
    }, 2000);
  }

  const handleCloseMessageModal = () => {
    setShowMessage(false);
  };

  useEffect(() => {
    if (showMessage === true) {
      const timeOut = setTimeout(() => {
        setShowMessage(false);
      }, 3000);

      return () => clearTimeout(timeOut);
    }
  }, [showMessage]);

  const customSearchStyles = {
    indicatorSeparator: () => ({
      display: "none",
    }),
    menu: (provided) => ({
      ...provided,
      position: "absolute",
      top: "100%",
      left: 0,
      margin: 0,
      padding: 0,
      height: "auto",
      overflowY: "visible",
      maxHeight: "none",
      zIndex: 99999,
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
      maxHeight: "none",
      overflowY: "visible",
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "40px",
      marginBottom: "0",
    }),
  };

  const handleAddStore = () => {
    const button = document.querySelector(".AddStoreBtn");
    button.classList.add("animate");

    window.history.pushState(
      null,
      "",
      "/E-Commerce/Settings/Location/Add-Store"
    );

    setTimeout(() => {
      setShowAddStore(true);
    }, 500);
  };

  const customStyles = {
    headCells: {
      style: {
        height: "52px",
        background: "transparent",
        opacity: "1",
        textAlign: "center",
        justifyContent: "center",
        border: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-medium)",
        fontSize: "var(--font-size-medium)",
      },
    },
    cells: {
      style: {
        height: "66px",
        justifyContent: "center",
        textAlign: "center",
        background: "transparent",
        borderTop: "--standered-border",
        borderRight: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-regular)",
        fontSize: "var(--font-size-small)",
      },
    },
  };

  const columns = [
    {
      name: (
        <input
          type="checkbox"
          style={{ margin: 0 }}
          onChange={(e) => console.log("All selected:", e.target.checked)}
        />
      ),
      cell: (row) => (loading ? <ShimmerLoader width="20px" height="20px" /> :
        <input
          type="checkbox"
          style={{ margin: 0 }}
          onChange={(e) => console.log("Selected:", row, e.target.checked)}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "50px",
    },
    {
      name: "Store Id",
      selector: (row) => (loading ? <ShimmerLoader width="60px" height="20px" borderRadius="10px" /> : row.store_id),
      minWidth: "100px",
      maxWidth: "135px",
    },
    {
      name: "Name",
      selector: (row) => (loading ? <ShimmerLoader width="80px" height="20px" borderRadius="20px" /> : row.name),
      minWidth: "100px",
      maxWidth: "150px",
    },
    {
      name: "Manager",
      selector: (row) => (loading ? <ShimmerLoader width="100px" height="20px" borderRadius="20px" /> : row.manager),
      minWidth: "160px",
      maxWidth: "200px",
    },
    {
      name: "Phone #",
      selector: (row) => (loading ? <ShimmerLoader width="90px" height="20px" borderRadius="20px" /> : row.phone),
      minWidth: "120px",
      maxWidth: "165px",
    },
    {
      name: "City",
      selector: (row) => (loading ? <ShimmerLoader width="90px" height="20px" borderRadius="20px" /> : row.city),
      minWidth: "115px",
      maxWidth: "165px",
    },
    {
      name: "State",
      selector: (row) => (loading ? <ShimmerLoader width="90px" height="20px" borderRadius="20px" /> : row.state),
      minWidth: "115px",
      maxWidth: "165px",
    },
    {
      name: "Postal Code",
      selector: (row) => (loading ? <ShimmerLoader width="90px" height="20px" borderRadius="15px" /> : row.postal_code),
      minWidth: "125px",
      maxWidth: "165px",
    },
    {
      name: "Action",
      cell: (row) => (loading ? <ShimmerLoader width="50px" height="20px" /> :
        <img
          src={actionIcon}
          alt="Action Icon"
          width="30"
          height="30"
          style={{ cursor: "pointer" }}
          onClick={() => console.log("Action clicked for:", row)}
        />
      ),
      minWidth: "110px",
      maxWidth: "125px",
    },
  ];

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const safeData = Array.isArray(data) ? data : [];

  const totalLocationPages = Math.ceil(safeData.length / rowsPerPage);

  const paginatedLocationData = safeData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handleLocationPrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleLocationNextPage = () => {
    if (currentPage < totalLocationPages) setCurrentPage(currentPage + 1);
  };

  const placeholderRows = Array(6).fill({ uid: "", name: "", image: "" });
  const displayedLocatorData = loading ? placeholderRows : paginatedLocationData;

  return (
    <>
      <div className="StoreLocatorPage">
        {showAddStore ? (
          <AddStore />
        ) : (
          <>
            <div className="Page_Row_01">
              <CustomBtn
                label="Add Store"
                withIcon={true}
                iconType="plus"
                className="AddStoreBtn"
                onClick={handleAddStore}
                type="submit"
              />
            </div>

            <div className="Locator-Table-Data">
              <div>
                <DataTable
                  columns={columns}
                  data={displayedLocatorData}
                  customStyles={customStyles}
                />
                <Pagination
                  activePageIndex={currentPage}
                  totalPages={totalLocationPages}
                  onPrevPage={handleLocationPrevPage}
                  onNextPage={handleLocationNextPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </>
        )}
      </div>
      
      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        handleCloseMessageModal={() => handleCloseMessageModal()}
      />
    </>
  );
};

export default StoreLocator;